import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess206702ParamStatus: 'idle',
    startProcess206702ParamError: undefined as any,
    loadUserParamsProcess206702ParamStatus: 'idle',
    loadUserParamsProcess206702ParamError: undefined as any,

    process206702ParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess206702Param = createAsyncThunk('process206702ParamSlice/startProcess206702Param', async ({ process206702Param }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess206702Param/`,
        prepareData(process206702Param),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess206702ParamStatus } = getState().process206702ParamSlice
        return startProcess206702ParamStatus !== 'pending'
    }
})

export const loadUserParamsProcess206702Param = createAsyncThunk('process206702ParamSlice/loadUserParamsProcess206702Param', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess206702Param/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess206702ParamStatus } = getState().process206702ParamSlice
        return loadUserParamsProcess206702ParamStatus !== 'pending'
    }
})

const Process206702ParamSlice = createSlice({
    name: 'process206702ParamSlice',
    initialState,
    reducers: {
        resetstartProcess206702Param: (state) => {
            state.job = undefined
            state.startProcess206702ParamError = undefined
        },
        resetstartProcess206702ParamError: (state) => {
            state.startProcess206702ParamError = undefined
        },
        resetloadUserParamsProcess206702Param: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess206702ParamError = undefined
        },
        resetloadUserParamsProcess206702ParamError: (state) => {
            state.loadUserParamsProcess206702ParamError = undefined
        },
        removeFromProcess206702ParamListById: (state, action) => {
            state.process206702ParamList = state.process206702ParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess206702ParamListByIds: (state, action) => {
            state.process206702ParamList = state.process206702ParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process206702ParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess206702ParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process206702ParamList = []
            state.startProcess206702ParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess206702Param.pending, (state) => {
            state.startProcess206702ParamStatus = 'pending'
            state.startProcess206702ParamError = undefined
        })
        builder.addCase(startProcess206702Param.fulfilled, (state, action) => {
            state.startProcess206702ParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess206702Param.rejected, (state, action) => {
            state.startProcess206702ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess206702ParamError = action.error.message
            } else {
                state.startProcess206702ParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess206702Param.pending, (state) => {
            state.loadUserParamsProcess206702ParamStatus = 'pending'
            state.loadUserParamsProcess206702ParamError = undefined
        })
        builder.addCase(loadUserParamsProcess206702Param.fulfilled, (state, action) => {
            state.loadUserParamsProcess206702ParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess206702Param.rejected, (state, action) => {
            state.loadUserParamsProcess206702ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess206702ParamError = action.error.message
            } else {
                state.loadUserParamsProcess206702ParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess206702Param,
    resetstartProcess206702ParamError,
    resetloadUserParamsProcess206702Param,
    resetloadUserParamsProcess206702ParamError,
    removeFromProcess206702ParamListById,
    removeFromProcess206702ParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process206702ParamSlice.actions
export default Process206702ParamSlice.reducer
